// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let QueryParamUtils = require("../../common/QueryParamUtils.bs.js");

function getDefaultState() {
  return {
    rentalMode: false,
    active: true,
    withdrawnOrExpired: false,
    inContract: false,
    purchasedOrRented: false
  };
}

function toParams(p) {
  let defaultState = getDefaultState();
  let rentalMode = Stdlib_Option.getOr(p.rentalMode, defaultState.rentalMode);
  let active = Stdlib_Option.getOr(p.active, defaultState.active);
  return {
    after: p.after,
    before: p.before,
    rentalMode: rentalMode,
    areaIds: p.areaIds,
    maxPrice: p.maxPrice,
    minPrice: p.minPrice,
    buyerNeedPropertyTypes: p.buyerNeedPropertyTypes,
    rentalNeedPropertyTypes: p.rentalNeedPropertyTypes,
    keywords: p.keywords,
    active: active,
    withdrawnOrExpired: Stdlib_Option.getOr(p.withdrawnOrExpired, defaultState.withdrawnOrExpired),
    inContract: Stdlib_Option.getOr(p.inContract, defaultState.inContract),
    purchasedOrRented: Stdlib_Option.getOr(p.purchasedOrRented, defaultState.purchasedOrRented)
  };
}

function fromUrl(params) {
  let rentalMode = QueryParamUtils.bool(params, "rentalMode");
  let areaIds = QueryParamUtils.stringArrNonEmpty(params, "areaIds");
  let maxPrice = QueryParamUtils.int(params, "maxPrice");
  let minPrice = QueryParamUtils.int(params, "minPrice");
  let buyerNeedPropertyTypes = Stdlib_Array.filterMap(params.getAll("buyerNeedPropertyTypes"), v => {
    switch (v) {
      case "CONDO" :
        return "CONDO";
      case "LOT" :
        return "LOT";
      case "MULTI_UNIT" :
        return "MULTI_UNIT";
      case "SINGLE_FAMILY" :
        return "SINGLE_FAMILY";
      default:
        return;
    }
  });
  let buyerNeedPropertyTypes$1 = buyerNeedPropertyTypes.length !== 0 ? buyerNeedPropertyTypes : undefined;
  let rentalNeedPropertyTypes = Stdlib_Array.filterMap(params.getAll("rentalNeedPropertyTypes"), v => {
    switch (v) {
      case "CONDO" :
        return "CONDO";
      case "SINGLE_FAMILY" :
        return "SINGLE_FAMILY";
      default:
        return;
    }
  });
  let rentalNeedPropertyTypes$1 = rentalNeedPropertyTypes.length !== 0 ? rentalNeedPropertyTypes : undefined;
  let withdrawnOrExpired = QueryParamUtils.bool(params, "withdrawnOrExpired");
  let purchasedOrRented = QueryParamUtils.bool(params, "purchasedOrRented");
  let inContract = QueryParamUtils.bool(params, "inContract");
  let keywords = QueryParamUtils.stringArrNonEmpty(params, "keywords");
  let after = QueryParamUtils.string(params, "after");
  let before = Stdlib_Option.isNone(after) ? QueryParamUtils.string(params, "before") : undefined;
  let active = Stdlib_Option.getOr(QueryParamUtils.bool(params, "active"), true);
  return {
    before: before,
    after: after,
    rentalMode: rentalMode,
    areaIds: areaIds,
    maxPrice: maxPrice,
    minPrice: minPrice,
    buyerNeedPropertyTypes: buyerNeedPropertyTypes$1,
    rentalNeedPropertyTypes: rentalNeedPropertyTypes$1,
    keywords: keywords,
    active: active,
    purchasedOrRented: purchasedOrRented,
    withdrawnOrExpired: withdrawnOrExpired,
    inContract: inContract
  };
}

let ParamsFromURL = {
  toParams: toParams,
  fromUrl: fromUrl
};

function transformParamsForApi(p) {
  let rentalNeedStatuses = [];
  let buyerNeedStatuses = [];
  if (p.active) {
    rentalNeedStatuses.push("ACTIVE");
    buyerNeedStatuses.push("ACTIVE");
  }
  if (p.inContract) {
    buyerNeedStatuses.push("IN_CONTRACT");
  }
  if (p.withdrawnOrExpired) {
    buyerNeedStatuses.push("WITHDRAWN", "EXPIRED");
    rentalNeedStatuses.push("WITHDRAWN", "EXPIRED");
  }
  if (p.purchasedOrRented) {
    buyerNeedStatuses.push("PURCHASED");
    rentalNeedStatuses.push("RENTED");
  }
  let first = Stdlib_Option.isNone(p.before) ? 12 : undefined;
  let last = Stdlib_Option.isSome(p.before) ? 12 : undefined;
  return {
    rentalMode: p.rentalMode,
    after: p.after,
    before: p.before,
    areaIds: p.areaIds,
    maxPrice: p.maxPrice,
    minPrice: p.minPrice,
    buyerNeedPropertyTypes: p.buyerNeedPropertyTypes,
    buyerNeedStatuses: buyerNeedStatuses,
    rentalNeedPropertyTypes: p.rentalNeedPropertyTypes,
    rentalNeedStatuses: rentalNeedStatuses,
    keywords: p.keywords,
    first: first,
    last: last
  };
}

let Params = {
  transformParamsForApi: transformParamsForApi
};

function toQueryString(params) {
  let searchParams = new URLSearchParams("");
  if (params.rentalMode) {
    QueryParamUtils.setIfExists(searchParams, "rentalMode", "true", s => s);
  }
  QueryParamUtils.setIfExistsArrStr(searchParams, "areaIds", params.areaIds);
  QueryParamUtils.setIfExistsInt(searchParams, "minPrice", params.minPrice);
  QueryParamUtils.setIfExistsInt(searchParams, "maxPrice", params.maxPrice);
  QueryParamUtils.setIfExistsArr(searchParams, "buyerNeedPropertyTypes", params.buyerNeedPropertyTypes, v => v);
  QueryParamUtils.setIfExistsArr(searchParams, "rentalNeedPropertyTypes", params.rentalNeedPropertyTypes, v => v);
  QueryParamUtils.setIfExistsArrStr(searchParams, "keywords", params.keywords);
  QueryParamUtils.setIfExists(searchParams, "after", params.after, s => s);
  if (Stdlib_Option.isNone(params.after)) {
    QueryParamUtils.setIfExists(searchParams, "before", params.before, s => s);
  }
  if (!params.active) {
    QueryParamUtils.setIfExistsBool(searchParams, "active", params.active);
  }
  if (params.purchasedOrRented) {
    QueryParamUtils.setIfExistsBool(searchParams, "purchasedOrRented", params.purchasedOrRented);
  }
  if (params.inContract) {
    QueryParamUtils.setIfExistsBool(searchParams, "inContract", params.inContract);
  }
  if (params.withdrawnOrExpired) {
    QueryParamUtils.setIfExistsBool(searchParams, "withdrawnOrExpired", params.withdrawnOrExpired);
  }
  let str = searchParams.toString();
  if (str === "") {
    return "";
  } else {
    return "?" + str;
  }
}

function getCurrentParams() {
  return QueryParamUtils.URLHelpers.getCurrentParams(fromUrl, toParams);
}

function paramsToUrl(params) {
  let location = window.location;
  return location.pathname + toQueryString(params);
}

function setQueryParamsInURL(mode, params) {
  QueryParamUtils.URLHelpers.setQueryParamsInURL(paramsToUrl, toParams, fromUrl, mode, params);
}

function use() {
  return QueryParamUtils.URLHelpers.use(fromUrl, toParams, setQueryParamsInURL);
}

function preserveRelevantParamsWhenSwitchingModes(p) {
  return {
    rentalMode: p.rentalMode,
    areaIds: p.areaIds,
    keywords: p.keywords,
    active: p.active,
    withdrawnOrExpired: p.withdrawnOrExpired,
    inContract: p.inContract,
    purchasedOrRented: p.purchasedOrRented
  };
}

exports.getDefaultState = getDefaultState;
exports.ParamsFromURL = ParamsFromURL;
exports.Params = Params;
exports.toQueryString = toQueryString;
exports.getCurrentParams = getCurrentParams;
exports.paramsToUrl = paramsToUrl;
exports.setQueryParamsInURL = setQueryParamsInURL;
exports.use = use;
exports.preserveRelevantParamsWhenSwitchingModes = preserveRelevantParamsWhenSwitchingModes;
/* QueryParamUtils Not a pure module */
